<template>
  <div class="modal" tabindex="-1" :id="id" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-ice">
        <div class="modal-header bg-cosmos p-3">
          <span>{{ headerTitel }}</span>
          <modal-close-button @confirmed="onCancel" />
        </div>
        <div class="modal-body">
          <p v-if="text !== null" v-html="replaceWithBr()"></p>
          <slot></slot>
        </div>
        <div class="modal-footer">
          <div class="row w-100">
            <div class="col-12 text-center">
              <button
                v-show="cancel"
                type="button"
                class="btn btn-danger mr-3"
                data-dismiss="modal"
                @click="onCancel"
              >
                <span class="font-khand font-weight-bold">{{
                  cancelText
                }}</span>
              </button>
              <button
                v-show="repeat"
                type="button"
                class="btn btn-primary mr-3"
                data-dismiss="modal"
                @click="onRepeat"
              >
                <span class="font-khand font-weight-bold">{{
                  repeatText
                }}</span>
              </button>
              <button
                v-show="ok"
                type="button"
                class="btn btn-success"
                @click="onOk"
              >
                <span class="font-khand font-weight-bold">{{ okText }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modal } from "@/mixins/Modal";
import ModalCloseButton from "@/components/global/ModalCloseButton";

export default {
  name: "Messagebox",
  components: {
    ModalCloseButton,
  },
  props: {
    headerText: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      default: "messagebox-enhanced-modal",
    },
    ok: {
      type: Boolean,
      default: false,
    },
    cancel: {
      type: Boolean,
      default: true,
    },
    repeat: {
      type: Boolean,
      default: false,
    },
    okText: {
      type: String,
      default: "OK",
    },
    cancelText: {
      type: String,
      default: "Abbrechen",
    },
    repeatText: {
      type: String,
      default: "Wiederholen",
    },
  },
  data() {
    return {
      text: null,
      headerTitel: null,
    };
  },
  mixins: [modal],
  mounted() {
    this.$bus.$on("openMessageBoxEnhanced", (data) => {
      if (data.id != null && data.id != this.id) return;

      this.text = data.text ? data.text : this.text;
      this.headerTitel = data.headerText ? data.headerText : this.headerText;

      $("#" + this.id).modal({
        backdrop: "static",
        keyboard: false,
      });
    });
  },
  methods: {
    closeModal() {
      $("#" + this.id).modal("hide");
    },
    onCancel() {
      this.closeModal();
      this.$emit("cancel");
    },
    onOk() {
      this.closeModal();
      this.$emit("ok");
    },
    onRepeat() {
      this.closeModal();
      this.$emit("repeat");
    },
    replaceWithBr() {
      return this.text.replace(/\n/g, "<br />");
    },
  },
};
</script>
